import { defaultCurrency } from "@zapier/currency";
import { useQuery as defaultUseQuery, useMutation as defaultUseMutation, } from "@apollo/react-hooks";
import { useCurrencies, useCurrentAccount, useNextPlan, } from "@zapier/upsells/esm/hooks";
import { BillingInterval, } from "@zapier/upsells/esm/types";
import { useAutoUpgradeFeatureEnrollment } from "./useAutoUpgradeFeatureEnrollment";
export const useAutoUpgrade = ({ onSetAutoUpgradeFailure = () => {
}, onSetAutoUpgradeSuccess = () => {
}, useMutation = defaultUseMutation, useQuery = defaultUseQuery, } = {}) => {
    var _a, _b, _c;
    const { currencies, error: currenciesError, isLoading: isLoadingCurrencies, } = useCurrencies({ useQuery });
    const { currentAccount, error: accountError, isLoading: isLoadingAccount, } = useCurrentAccount({ useQuery });
    const { error: nextPlanError, isLoading: isLoadingNextPlan, nextPlan, } = useNextPlan({
        accountId: currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.id,
        interval: BillingInterval.month,
        skip: !(currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.id),
        useQuery,
    });
    const { error: autoUpgradeError, isAutoUpgradeEnabled, isEligibleForAutoUpgrade, isLoading: isLoadingAutoUpgrade, setAutoUpgrade, } = useAutoUpgradeFeatureEnrollment({
        accountId: currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.id,
        featureEnrollmentList: currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.featureEnrollmentList,
        onSetAutoUpgradeFailure,
        onSetAutoUpgradeSuccess,
        upgradePlanId: nextPlan === null || nextPlan === void 0 ? void 0 : nextPlan.id,
        useMutation,
    });
    return {
        account: currentAccount,
        accountCurrency: (_a = currencies === null || currencies === void 0 ? void 0 : currencies.find((c) => c.name === (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.currency))) !== null && _a !== void 0 ? _a : defaultCurrency,
        autoUpgradeToPlan: nextPlan,
        error: (_c = (_b = accountError !== null && accountError !== void 0 ? accountError : currenciesError) !== null && _b !== void 0 ? _b : nextPlanError) !== null && _c !== void 0 ? _c : autoUpgradeError,
        isAutoUpgradeEnabled,
        isEligibleForAutoUpgrade,
        isLoading: isLoadingAccount ||
            isLoadingCurrencies ||
            isLoadingNextPlan ||
            isLoadingAutoUpgrade,
        setAutoUpgrade,
    };
};

// @zapier/upsells@8.0.1 (466b4077f)
